<template>
  <v-row class="pt-10 justify-center">
    <v-text-field
      :id="inputNameId"
      v-model.trim="inputNameValue"
      :label="inputNameLabel"
      hide-details="auto"
      variant="outlined"
      density="compact"
      class="name-input"
      :placeholder="inputNamePlaceholder"
      :disabled="props.isViewMode"
      :rules="[(inputName: string) => (inputName === '' ? 'Name must not be empty' : true)]"
      @update:model-value="emitName(inputNameValue)"
    />
  </v-row>
  <v-row v-if="enableDescription" class="justify-center mt-0 mb-4">
    <v-textarea
      :id="inputDescriptionId"
      v-model.trim="inputDescriptionValue"
      :label="inputDescriptionLabel"
      hide-details="auto"
      variant="outlined"
      density="compact"
      class="description-input"
      :placeholder="inputDescriptionPlaceholder"
      :disabled="props.isViewMode"
      :rules="[
        (inputDescription: string) =>
          inputDescriptionOptional === false && inputDescription === ''
            ? 'Description must not be empty'
            : true,
      ]"
      @update:model-value="emitDescription(inputDescriptionValue)"
    />
  </v-row>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue'

  const props = defineProps({
    inputNameId: { type: String, default: '' },
    inputName: { type: String, default: '' },
    inputNameLabel: { type: String, required: true },
    inputNamePlaceholder: { type: String, required: true },
    inputDescriptionId: { type: String, default: '' },
    inputDescription: { type: String, default: '' },
    inputDescriptionLabel: { type: String, default: '' },
    inputDescriptionPlaceholder: { type: String, default: '' },
    inputDescriptionOptional: { type: Boolean, default: true },
    enableDescription: { type: Boolean, default: true },
    isViewMode: { type: Boolean, default: false },
  })

  const emit = defineEmits<{
    (event: 'nameInput', value: string): void
    (event: 'descriptionInput', value: string): void
  }>()

  function emitName(nameToEmit: string): void {
    emit('nameInput', nameToEmit)
  }

  function emitDescription(descriptionToEmit: string): void {
    emit('descriptionInput', descriptionToEmit)
  }

  const inputNameValue = ref<string>(props.inputName)
  watch(
    () => props.inputName,
    () => (inputNameValue.value = props.inputName),
  )
  const inputDescriptionValue = ref<string>(props.inputDescription ?? '')
  watch(
    () => props.inputDescription,
    () => (inputDescriptionValue.value = props.inputDescription),
  )
</script>

<style scoped>
  .inline-header-container {
    display: inline-flex;
    align-items: center;
  }

  .edit-icon {
    margin-left: 10px; /* Add space between the text and the icon */
  }

  .name-input,
  .description-input {
    max-width: 550px;
    margin-bottom: 20px;
    min-width: 400px;
  }
</style>
